<div class="content-wrapper">
  <div class="content liveCounter">
    <div class="container-fluid">
      <div class="row">
        <!-- registration today section start  -->
        <!-- <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 padlr15px mb-3">
          <div class="counterBox gradient-pink min-ht register-today">
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xl-12 p-0">
                <div class="counterUpdate">
                  <div class="container-fluid">
                    <div class="icon-box">
                      <span class="registrations-today-icon"></span>
                    </div>
                    <h3 class="accessibility-plugin-ac">Registrations Today</h3>
                    <span
                      class="mobileCount countColorwhite accessibility-plugin-ac"
                      [countUp]="totalRegistrationCounter"
                      [options]="options"
                      >0</span
                    >
                  </div>
                </div>
              </div>
              <div class="reg-chart">
                <div class="chartAreaWrapper-vacc">
                  <canvas
                    *ngIf="
                      !deviceService.isMobile();
                      else mobileLiveVaccinationStreamingReg
                    "
                    id="liveVaccStreamingReg"
                    width="315"
                    height="200"
                  ></canvas>
                  <ng-template #mobileLiveVaccinationStreamingReg>
                    <canvas
                      id="liveVaccStreamingReg"
                      width="120"
                      height="50"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 padlr6px mb-3">
          <div class="row">
            <!-- registration today section start  -->

            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-pink">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="registrations-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac">
                          Registrations</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="totalRegistrationCounter"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else mobileLiveVaccinationStreamingReg
                      "
                      id="liveVaccStreamingReg"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobileLiveVaccinationStreamingReg>
                      <canvas
                        id="liveVaccStreamingReg"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <!-- vaccination today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-blue">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="vaccination-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac"
                          >Vaccinations</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="totalVaccinationCounter"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else mobileLiveVaccinationStreaming
                      "
                      id="liveVaccStreaming"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobileLiveVaccinationStreaming>
                      <canvas
                        id="liveVaccStreaming"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!-- vaccination today section start  -->
            <!-- Partially Vaccinated Today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-orange">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="partially-vaccinated-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac"
                          >Partially Vaccinated</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="partialVaccinationCounter"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>

                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else mobileLiveVaccinationStreamingPartialVacc
                      "
                      id="liveVaccStreamingPartialVacc"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobileLiveVaccinationStreamingPartialVacc>
                      <canvas
                        id="liveVaccStreamingPartialVacc"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!-- Partially Vaccinated Today section start  -->
            <!-- Fully Vaccinated Today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-green">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="fully-vaccinated-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac">
                          Fully Vaccinated</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="fullyVaccinationCounter"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else mobileLiveVaccinationStreamingFullyVacc
                      "
                      id="liveVaccStreamingFullyVacc"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobileLiveVaccinationStreamingFullyVacc>
                      <canvas
                        id="liveVaccStreamingFullyVacc"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fully Vaccinated Today section start  -->
            <!-- 12-14 vaccination today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-sofyellow">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="age12-14-vaccinated-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac">
                          12-14 Vaccinations</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="total12_14Vaccination"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else mobile12_14Vacc"
                      id="liveVacc12_14"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobile12_14Vacc>
                      <canvas
                        id="liveVacc12_14"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!-- 12-14 vaccination today section end  -->
            <!-- 15-17 vaccination today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-purple">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="vaccinated-15-17-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac">
                          15-17 Vaccinations</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="total15_17Vaccination"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else mobile15_17Vacc"
                      id="liveVacc15_17"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobile15_17Vacc>
                      <canvas
                        id="liveVacc15_17"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!-- 15-17 vaccination today section end  -->
            <!-- HCW/FLW Precaution Doses Today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-deepSky">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="healthworker-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac"
                          >18-59 Precaution Doses</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="total_hcw_flw_precaution_vaccinations"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else mobile18_44Vacc"
                      id="liveVacc18_44"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobile18_44Vacc>
                      <canvas
                        id="liveVacc18_44"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!--  HCW/FLW Precaution Doses Today section end  -->
            <!-- 60+ Precaution Doses Today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox gradient-watermelon">
                <div class="row">
                  <div class="col-md-4 col-lg-4 col-xl-4 p-0">
                    <div class="icon-box">
                      <span class="plus60-vaccinated-today-icon"></span>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8 p-0">
                    <div class="counterUpdate">
                      <h3 class="accessibility-plugin-ac">
                        <span class="vt-title accessibility-plugin-ac"
                          >60+ Precaution Doses</span
                        >
                        <span class="today-box accessibility-plugin-ac"
                          >Today</span
                        >
                      </h3>
                      <span
                        class="mobileCount countColorwhite accessibility-plugin-ac"
                        [countUp]="total_60_plus_precaution_vaccinations"
                        [options]="options"
                        >0</span
                      >
                    </div>
                  </div>
                  <div class="chartAreaWrapper-vacc">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else mobile45_60Vacc"
                      id="liveVacc45_60"
                      width="315"
                      height="50"
                    ></canvas>
                    <ng-template #mobile45_60Vacc>
                      <canvas
                        id="liveVacc45_60"
                        width="120"
                        height="50"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <!--60+ Precaution Doses Today section end  -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col floating-menu">
    <div class="dropdown">
      <button class="dropbtn">
        <div class="filter-block">
          <span
            [ngClass]="FilterIcon ? 'filter-exapand-icon' : 'filter-icon'"
            (click)="closeFilter()"
            tooltip="Filter"
          ></span
          ><span
            class="sep-line"
            [ngClass]="exportIcon ? 'filter-exapand-icon' : 'export-icon'"
            (click)="exportDashboard()"
            tooltip="Export"
          ></span>
        </div>
      </button>
      <div
        id="myDropdown"
        class="dropdown-content accessibility-plugin-ac"
        [ngClass]="hideShowFilter ? 'd-block' : 'd-none'"
      >
        <input
          type="text"
          placeholder="Search.."
          id="myInput"
          class="accessibility-plugin-ac"
          (keyup)="filterFunction()"
        />
        <div class="dropdown-scroll" id="accordion">
          <div class="state-block">
            <a role="button" class="dropdown-list" (click)="loadIndiadata()">
              <span class="accessibility-plugin-ac">India </span>
            </a>
          </div>
          <div class="state-block" *ngFor="let state of states; let i = index">
            <a
              role="button"
              class="dropdown-list"
              (click)="loadDataByStateTab(state.state_name, '')"
              data-toggle="collapse"
              href="#collapse-{{ i }}"
              aria-expanded="true"
              aria-controls="collapse-{{ i }}"
            >
              <span class="accessibility-plugin-ac"
                >{{ state.state_name }}
              </span>
              <i
                class="my-icon fa"
                [ngClass]="
                  iconClass == state.state_id
                    ? 'fa-chevron-up'
                    : 'fa-chevron-down'
                "
              ></i>
            </a>
            <div
              class="district-block dropdown-subscroll collapse"
              id="collapse-{{ i }}"
              data-parent="#accordion"
            >
              <div
                class="dropdown-list accessibility-plugin-ac"
                *ngFor="let district of state.districtList"
                (click)="loadDataByDitrictTab(district.district_name)"
              >
                {{ district.district_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="myDropdown2"
        class="dropdown-content export"
        [ngClass]="hideShowExport ? 'd-block' : 'd-none'"
        title="Export"
      >
        <div class="dropdown-scroll">
          <div class="dropdown-list" (click)="ExportDashboardDataInJson()">
            <span class="accessibility-plugin-ac">Json</span>
          </div>
          <div class="dropdown-list" (click)="ExportDashboardDataInExcel()">
            <span class="accessibility-plugin-ac">Excel</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="content-block">
    <div class="container-fluid main-card-block">
      <div class="row">
        <div
          class="col-6 col-sm-12 margin-b cardblockcls"
          [ngClass]="state_id || district_id ? 'col-lg-6' : 'col-lg-4'"
        >
          <div class="small-box bg-white cm-vaccinated-box">
            <div class="icon icon-bg-vaccine">
              <span class="total-vaccination-doses-icon"></span>
            </div>
            <div class="inner innerbox">
              <p class="titlemob accessibility-plugin-ac">
                {{ "DASHBOARD.Total_Vaccination_Doses" | translate }}
                <span
                  tooltip="Total number of doses administered till date includes 52,68,253 doses administered outside CoWIN"
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  placement="bottom"
                >
                  <img class="infoicon" src="assets/images/info_icon.svg" />
                </span>
              </p>
              <h3 class="accessibility-plugin-ac">
                <span class="cls_today accessibility-plugin-ac">{{
                  topBlockReport?.vaccination?.total_doses | numberFormat
                }}</span>
              </h3>
              <div class="row m-0 r-0 w-100">
                <div class="col pl-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp">{{
                      "DASHBOARD.Dose_1" | translate
                    }}</small>
                  </div>
                  <span
                    class="d--block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                    >{{
                      topBlockReport?.vaccination?.tot_dose_1 | numberFormat
                    }}</span
                  >
                </div>
                <div class="col pr-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp">{{
                      "DASHBOARD.Dose_2" | translate
                    }}</small>
                  </div>
                  <span
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                    >{{
                      topBlockReport?.vaccination?.tot_dose_2 | numberFormat
                    }}</span
                  >
                </div>
                <div class="col pr-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp">{{
                      "Precaution Dose" | translate
                    }}</small>
                  </div>
                  <span
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                    >{{
                      topBlockReport?.vaccination?.tot_pd | numberFormat
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-6 col-sm-12 margin-b cardblockcls"
          [ngClass]="state_id || district_id ? 'col-lg-6' : 'col-lg-4'"
        >
          <div class="small-box bg-white dash-box cm-site-conduct-box">
            <div class="icon">
              <span class="site-conducting-vaccination-icon"></span>
            </div>
            <div class="inner innerbox">
              <p class="titlemob accessibility-plugin-ac">
                {{ "DASHBOARD.Sites_Conducting_Vaccination" | translate }}
                <span
                  tooltip="Total private health facilities & public health facilities conducting vaccination today."
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  placement="bottom"
                >
                  <img class="infoicon" src="assets/images/info_icon.svg" />
                </span>
              </p>
              <h3 class="accessibility-plugin-ac">
                <span class="cls_today accessibility-plugin-ac">{{
                  topBlockReport?.sites?.total | numberFormat
                }}</span>
              </h3>
              <div class="row m-0 r-0 w-100">
                <div class="col pl-0 text-center">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp">{{
                      "DASHBOARD.Government" | translate
                    }}</small>
                  </div>
                  <p
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                  >
                    {{ topBlockReport?.sites?.govt | numberFormat }}
                  </p>
                </div>
                <div class="col pr-0 text-center">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp">{{
                      "DASHBOARD.Private" | translate
                    }}</small>
                  </div>
                  <p
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                  >
                    {{ topBlockReport?.sites?.pvt | numberFormat }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-sm-12 cardblockcls col-6 margin-b"
          *ngIf="!this.state_id"
        >
          <div class="small-box bg-white dash-box cm-reg-box">
            <div class="">
              <div class="icon icon-bg-beneficiary">
                <span class="total-registrations-icon"></span>
              </div>
            </div>
            <div class="inner innerbox">
              <p class="titlemob accessibility-plugin-ac">
                Total Registrations
                <span
                  tooltip="Total number of beneficiaries registered via online & offline mode till date,
                            including Front Line Workers(FLW) & Health Care Workers(HCW) "
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  placement="bottom"
                >
                  <img class="infoicon" src="assets/images/info_icon.svg" />
                </span>
              </p>
              <h3 class="accessibility-plugin-ac">
                <span class="cls_today">{{
                  topBlockReport?.registration?.total | numberFormat
                }}</span>
              </h3>
              <div class="row m-0 r-0 w-100">
                <div class="col-6 col-md-3 col-lg-3 pl-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp"
                      >Age 12-14
                    </small>
                  </div>
                  <p
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                  >
                    {{ topBlockReport?.registration?.cit_12_14 | numberFormat }}
                  </p>
                </div>
                <div class="col-6 col-md-3 col-lg-3 pl-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp"
                      >{{ "Age 15-17" | translate }}
                    </small>
                  </div>
                  <p
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                  >
                    {{ topBlockReport?.registration?.cit_15_17 | numberFormat }}
                  </p>
                </div>
                <div class="col-6 col-md-3 col-lg-3 pl-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp"
                      >{{ "DASHBOARD.Age_18-44" | translate }}
                    </small>
                  </div>
                  <p
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                  >
                    {{ topBlockReport?.registration?.cit_18_45 | numberFormat }}
                  </p>
                </div>
                <div class="col-6 col-md-3 col-lg-3 pl-0 text-left">
                  <div>
                    <small class="text-muted accessibility-plugin-ac txt-sp"
                      >{{ "DASHBOARD.Age_45+" | translate }}
                    </small>
                  </div>
                  <p
                    class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac sm-txt"
                  >
                    {{
                      topBlockReport?.registration?.cit_45_above | numberFormat
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <section class="col-lg-12 connectedSortable cm-vc-trends">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title blocktitle accessibility-plugin-ac">
                {{ "DASHBOARD.Vaccination_Trends" | translate }}
                <span
                  [hidden]="!isday && !isdayVaccAge"
                  tooltip="Vaccination trend for today."
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  class="accessibility-plugin-ac"
                  placement="bottom"
                >
                  <img class="infoicon" src="assets/images/info_icon.svg" />
                </span>
                <span
                  [hidden]="!ismonth && !ismonthVaccAge"
                  tooltip="Vaccination trend for last 30 days."
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  placement="bottom"
                >
                  <img class="infoicon" src="assets/images/info_icon.svg" />
                </span>
                <span
                  [hidden]="!isweek && !isweekVaccAge"
                  tooltip="Vaccination trend since beginning"
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  placement="bottom"
                >
                  <img class="infoicon" src="assets/images/info_icon.svg" />
                </span>
              </h3>
            </div>
            <div class="card-header">
              <div class="card-subtitle">
                <div class="cm-bttn-wrap-new">
                  <ul>
                    <li [ngClass]="{ active: isByDoses }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVaccByTab('By Doses')"
                      >
                        {{ "DASHBOARD.By_Doses" | translate }}
                      </button>
                    </li>
                    <li [ngClass]="{ active: isByAge }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVaccByTab('By Age')"
                      >
                        {{ "DASHBOARD.By_Age" | translate }}
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="cm-bttn-wrap" [hidden]="!isByDoses">
                  <ul>
                    <li class="active" [ngClass]="{ active: isday }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVaccByTab('Today')"
                      >
                        {{ "DASHBOARD.Today" | translate }}
                      </button>
                    </li>
                    <li [ngClass]="{ active: ismonth }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVacChartData('Last 30 Days')"
                      >
                        {{ "DASHBOARD.Last_30_Days" | translate }}
                      </button>
                    </li>
                    <li [ngClass]="{ active: isweek }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVacChartData('All')"
                      >
                        {{ "DASHBOARD.All" | translate }}
                      </button>
                    </li>
                  </ul>
                </div>

                <div class="cm-bttn-wrap" [hidden]="!isByAge">
                  <ul>
                    <li [ngClass]="{ active: isdayVaccAge }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVaccChartAgewiseDataToday('Today')"
                      >
                        {{ "DASHBOARD.Today" | translate }}
                      </button>
                    </li>
                    <li [ngClass]="{ active: ismonthVaccAge }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVaccChartAgewiseDataMonth('Last 30 Days')"
                      >
                        {{ "DASHBOARD.Last_30_Days" | translate }}
                      </button>
                    </li>
                    <li [ngClass]="{ active: isweekVaccAge }">
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                        (click)="getVaccChartAgewiseDataAll('All')"
                      >
                        {{ "DASHBOARD.All" | translate }}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="card-body" [hidden]="!isday">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="!deviceService.isMobile(); else mobileRealtimeCNVS"
                    id="realtime"
                    width="600"
                    height="160"
                  ></canvas>
                  <ng-template #mobileRealtimeCNVS>
                    <canvas id="realtime" width="600" height="400"></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="card-body" [hidden]="!ismonth">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="
                      !deviceService.isMobile();
                      else mobileRealtimeCNVSmonth
                    "
                    id="realtimemonth"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #mobileRealtimeCNVSmonth>
                    <canvas
                      id="realtimemonth"
                      width="600"
                      height="300"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="card-body" [hidden]="!isweek">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="
                      !deviceService.isMobile();
                      else mobileRealtimeCNVSweek
                    "
                    id="realtimeweek"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #mobileRealtimeCNVSweek>
                    <canvas id="realtimeweek" width="600" height="300"></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="card-body" [hidden]="!isdayVaccAge">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="!deviceService.isMobile(); else VaccAgewiseToday"
                    id="vacc-agewise-today"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #VaccAgewiseToday>
                    <canvas
                      id="vacc-agewise-today"
                      width="600"
                      height="300"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="card-body" [hidden]="!ismonthVaccAge">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="!deviceService.isMobile(); else VaccAgewiseMonth"
                    id="vacc-agewise-month"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #VaccAgewiseMonth>
                    <canvas
                      id="vacc-agewise-month"
                      width="600"
                      height="300"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="card-body" [hidden]="!isweekVaccAge">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="!deviceService.isMobile(); else VaccAgewiseAll"
                    id="vacc-agewise-all"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #VaccAgewiseAll>
                    <canvas
                      id="vacc-agewise-all"
                      width="600"
                      height="300"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- <div class="row">
        <section class="col-lg-4 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Gender
              </h3>
            </div>
            <div class="card-body">
              <div class="chartAreaWrapper">
                <div class="chart-block">
                  <div class="chart-container">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else genderPieCanvas"
                      id="total-vaccinated-gender"
                      width="800"
                      height="600"
                    ></canvas>
                    <ng-template #genderPieCanvas>
                      <canvas
                        id="total-vaccinated-gender"
                        width="600"
                        height="400"
                      ></canvas>
                    </ng-template>
                  </div>

                  <div class="legend-block">
                    <div class="legend">
                      <span class="legend-dot darkblue-color"></span>
                      <span>Male</span>
                    </div>
                    <div class="legend">
                      <span class="legend-dot pink-color"></span>
                      <span>Female</span>
                    </div>

                    <div class="legend">
                      <span class="legend-dot orange-color"></span>
                      <span>Others</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-4 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Type
              </h3>
            </div>
            <div class="card-body">
              <div class="chartAreaWrapper">
                <div class="chart-block">
                  <div class="chart-container">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else materialPieCanvas"
                      id="material-used"
                      width="800"
                      height="600"
                    ></canvas>
                    <ng-template #materialPieCanvas>
                      <canvas
                        id="material-used"
                        width="600"
                        height="400"
                      ></canvas>
                    </ng-template>
                  </div>
                  <div class="legend-block">
                    <div class="legend">
                      <span class="legend-dot blue-color"></span>
                      <span>Covishield</span>
                    </div>
                    <div class="legend">
                      <span class="legend-dot red-color"></span>
                      <span>Covaxin</span>
                    </div>

                    <div class="legend">
                      <span class="legend-dot green-color"></span>
                      <span>Sputnik</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-4 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Age
              </h3>
            </div>
            <div class="card-body">
              <div class="chartAreaWrapper">
                <div class="chart-block">
                  <div class="chart-container">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else mobilevaccinationbyage
                      "
                      id="vaccination-by-age"
                      width="600"
                      height="365"
                    ></canvas>
                    <ng-template #mobilevaccinationbyage>
                      <canvas
                        id="vaccination-by-age"
                        width="600"
                        height="400"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> -->

      <!-- -----------------------For compare--------------------------------- -->
      <div class="row vac-group">
        <section class="col-lg-4 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Gender
              </h3>
            </div>
            <div class="card-body">
              <div class="chartAreaWrapper">
                <div class="chart-block">
                  <div class="chart-container">
                    <canvas
                      *ngIf="!deviceService.isMobile(); else genderPieCanvasnew"
                      id="total-vaccinated-gender-new"
                      width="800"
                      height="600"
                    ></canvas>
                    <ng-template #genderPieCanvasnew>
                      <canvas
                        id="total-vaccinated-gender-new"
                        width="800"
                        height="700"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-4 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Type
              </h3>
            </div>
            <div class="card-body">
              <div class="chartAreaWrapper">
                <div class="chart-block">
                  <div class="chart-container">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else materialPieCanvasnew
                      "
                      id="material-used-new"
                      width="800"
                      height="600"
                    ></canvas>
                    <ng-template #materialPieCanvasnew>
                      <canvas
                        id="material-used-new"
                        width="600"
                        height="400"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-4 connectedSortable">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Age
              </h3>
            </div>
            <div class="card-body">
              <div class="chartAreaWrapper">
                <div class="chart-block">
                  <div class="chart-container">
                    <canvas
                      *ngIf="
                        !deviceService.isMobile();
                        else mobilevaccinationbyagenew
                      "
                      id="vaccination-by-age-new"
                      width="730"
                      height="650"
                    ></canvas>
                    <ng-template #mobilevaccinationbyagenew>
                      <canvas
                        id="vaccination-by-age-new"
                        width="650"
                        height="700"
                      ></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- -------------------------------------------------------------------- -->
      <div class="row" *ngIf="!chartFlag">
        <section class="col-lg-12 connectedSortable chart-mob-scroll">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title blocktitle accessibility-plugin-ac">
                Vaccination Coverage by State/UT
              </h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-5 col-sm-12 cardblockcls col-5 text-center">
                  <app-heatmap-bubble
                    #Heatmap
                    [statename]="statename"
                  ></app-heatmap-bubble>
                </div>
                <div class="col-lg-7 col-sm-12 cardblockcls col-7">
                  <div class="statewise-vaccination vline">
                    <div class="sv-table-data">
                      <div class="table-scroll">
                        <div class="chart-mob-scroll cm-scrollbar">
                          <div class="chartAreaWrapper">
                            <div
                              class="table-row"
                              *ngFor="
                                let tableData of getVaccinationByStateUTData;
                                let i = index
                              "
                            >
                              <div class="table-col-1">
                                <div class="chartAreaWrapper">
                                  <div class="chart">
                                    <div
                                      class="donut"
                                      [style.--second]="
                                        getVacPerc(tableData, 2)
                                      "
                                      [style.--first]="getVacPerc(tableData, 1)"
                                    >
                                      <div
                                        class="donut__slice donut__slice__first"
                                      ></div>
                                      <div
                                        class="donut__slice donut__slice__second"
                                      ></div>
                                      <div class="donut__label"></div>
                                    </div>
                                    <!-- <div class="progress blue">
                                    <span class="progress-left">
                                      <span class="progress-bar"></span>
                                    </span>
                                      <span class="progress-right">
                                        <span class="progress-bar"></span>
                                      </span>
                                  </div> -->
                                    <!-- <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeRegmonth"
                                   id='vaccination-table-data{{i+1}}' width="100" height="80"></canvas>
                                  <ng-template #mobileRealtimeRegmonth>
                                        <canvas id="vaccination-table-data{{i+1}}" width="100" height="80"></canvas>
                                  </ng-template> -->
                                  </div>
                                </div>
                              </div>
                              <div class="table-col-2">
                                <div class="table-block-row">
                                  <div class="table-subrow">
                                    <span
                                      class="state-title accessibility-plugin-ac"
                                      >{{ tableData.title }}</span
                                    >
                                  </div>
                                  <div class="table-subrow">
                                    <div class="d-col-1">
                                      <div
                                        class="vac-title accessibility-plugin-ac"
                                      >
                                        Today
                                      </div>
                                      <div
                                        class="vac-data accessibility-plugin-ac"
                                      >
                                        {{ tableData.today | numberFormat }}
                                      </div>
                                    </div>
                                    <div class="d-col-2">
                                      <div
                                        class="vac-title accessibility-plugin-ac"
                                      >
                                        Total
                                      </div>
                                      <div
                                        class="vac-data accessibility-plugin-ac"
                                      >
                                        {{ tableData.total | numberFormat }}
                                      </div>
                                    </div>
                                    <div class="d-col-3">
                                      <div
                                        class="vac-title accessibility-plugin-ac"
                                      >
                                        Dose 1
                                      </div>
                                      <div
                                        class="vac-data d-txt-1 accessibility-plugin-ac"
                                      >
                                        {{
                                          tableData.partial_vaccinated
                                            | numberFormat
                                        }}
                                      </div>
                                    </div>
                                    <div class="d-col-4">
                                      <div
                                        class="vac-title accessibility-plugin-ac"
                                      >
                                        Dose 2
                                      </div>
                                      <div
                                        class="vac-data d-txt-2 accessibility-plugin-ac"
                                      >
                                        {{
                                          tableData.totally_vaccinated
                                            | numberFormat
                                        }}
                                      </div>
                                    </div>
                                    <div class="d-col-5">
                                      <div
                                        class="vac-title accessibility-plugin-ac"
                                      >
                                        Precaution Dose
                                      </div>
                                      <div
                                        class="vac-data d-txt-3 accessibility-plugin-ac"
                                      >
                                        {{
                                          tableData.precaution_dose
                                            | numberFormat
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="row" *ngIf="chartFlag">
        <section
          class="col-lg-12 connectedSortable chart-mob-scroll fullwidth-table-data vac-center"
        >
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                Vaccination By Centers
              </h3>
            </div>
            <div class="card-body">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 cardblockcls col-12">
                    <div class="sv-table-data">
                      <div class="table-scroll">
                        <div class="chart-mob-scroll cm-scrollbar">
                          <div class="chartAreaWrapper">
                            <div
                              class="table-row col-lg-6 col-sm-12 cardblockcls col-12"
                              *ngFor="
                                let tableData of getVaccinationByStateUTData;
                                let i = index
                              "
                            >
                              <div class="table-col-1">
                                <div class="chartAreaWrapper">
                                  <div class="chart">
                                    <div
                                      class="donut"
                                      [style.--second]="
                                        getVacPerc(tableData, 2)
                                      "
                                      [style.--first]="getVacPerc(tableData, 1)"
                                    >
                                      <div
                                        class="donut__slice donut__slice__first"
                                      ></div>
                                      <div
                                        class="donut__slice donut__slice__second"
                                      ></div>
                                      <div class="donut__label"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="table-col-2">
                                <div class="table-block-row">
                                  <div class="table-subrow">
                                    <span class="state-title">{{
                                      tableData.title
                                    }}</span>
                                  </div>
                                  <div class="table-subrow">
                                    <div class="d-col-1">
                                      <div class="vac-title">Today</div>
                                      <div class="vac-data">
                                        {{ tableData.today | numberFormat }}
                                      </div>
                                    </div>
                                    <div class="d-col-2">
                                      <div class="vac-title">Total</div>
                                      <div class="vac-data">
                                        {{ tableData.total | numberFormat }}
                                      </div>
                                    </div>
                                    <div class="d-col-3">
                                      <div class="vac-title">Dose 1</div>
                                      <div class="vac-data d-txt-1">
                                        {{
                                          tableData.partial_vaccinated
                                            | numberFormat
                                        }}
                                      </div>
                                    </div>
                                    <div class="d-col-4">
                                      <div class="vac-title">Dose 2</div>
                                      <div class="vac-data d-txt-2">
                                        {{
                                          tableData.totally_vaccinated
                                            | numberFormat
                                        }}
                                      </div>
                                    </div>
                                    <div class="d-col-5">
                                      <div class="vac-title">
                                        Precaution Dose
                                      </div>
                                      <div class="vac-data d-txt-3">
                                        {{
                                          tableData.precaution_dose
                                            | numberFormat
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="row" *ngIf="!this.state_id">
        <section
          class="col-lg-12 connectedSortable cm-vc-trends chart-mob-scroll"
        >
          <div class="card">
            <div class="card-header">
              <div class="card-header-title">
                <h3 class="card-title blocktitle accessibility-plugin-ac">
                  {{ "DASHBOARD.Registration_Trends" | translate }}
                  <span
                    [hidden]="!isdayReg"
                    tooltip="Registration trend for today."
                    aria-label="Button that displays a tooltip when focused or hovered over"
                    placement="bottom"
                  >
                    <img class="infoicon" src="assets/images/info_icon.svg" />
                  </span>
                  <span
                    [hidden]="!ismonthReg"
                    tooltip="Registration trend for last 30 days."
                    aria-label="Button that displays a tooltip when focused or hovered over"
                    placement="bottom"
                  >
                    <img class="infoicon" src="assets/images/info_icon.svg" />
                  </span>
                  <span
                    [hidden]="!isweekReg"
                    tooltip="Registration trend since beginning"
                    aria-label="Button that displays a tooltip when focused or hovered over"
                    placement="bottom"
                  >
                    <img class="infoicon" src="assets/images/info_icon.svg" />
                  </span>
                </h3>
                <div class="cm-bttn-wrap">
                  <ul class="reg-trends">
                    <li
                      [ngClass]="{ active: isdayReg }"
                      (click)="getVaccByTab('isdayReg')"
                    >
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                      >
                        {{ "DASHBOARD.Today" | translate }}
                      </button>
                    </li>
                    <li
                      [ngClass]="{ active: ismonthReg }"
                      (click)="getRegChartDataMonth('Last 30 Days')"
                    >
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                      >
                        {{ "DASHBOARD.Last_30_Days" | translate }}
                      </button>
                    </li>
                    <li
                      [ngClass]="{ active: isweekReg }"
                      (click)="getRegChartDataAll('All')"
                    >
                      <button
                        type="button"
                        class="btn btn-tool accessibility-plugin-ac"
                      >
                        {{ "DASHBOARD.All" | translate }}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-body" [hidden]="!isdayReg">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="!deviceService.isMobile(); else mobileRealtimereg"
                    id="realtimeregchart"
                    width="600"
                    height="160"
                  ></canvas>
                  <ng-template #mobileRealtimereg>
                    <canvas
                      id="realtimeregchart"
                      width="600"
                      height="400"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="card-body" [hidden]="!ismonthReg">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="
                      !deviceService.isMobile();
                      else mobileRealtimeRegmonth
                    "
                    id="realtimeregchartmonth"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #mobileRealtimeRegmonth>
                    <canvas
                      id="realtimeregchartmonth"
                      width="600"
                      height="300"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="card-body" [hidden]="!isweekReg">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="
                      !deviceService.isMobile();
                      else mobileRealtimeRegweek
                    "
                    id="realtimeregweek"
                    width="200"
                    height="50"
                  ></canvas>
                  <ng-template #mobileRealtimeRegweek>
                    <canvas
                      id="realtimeregweek"
                      width="600"
                      height="300"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="row">
        <section class="col-lg-6 connectedSortable chart-mob-scroll">
          <div class="card">
            <div class="card-header">
              <div class="aefi-title">
                <h3
                  class="card-title blocktitle w-ltd accessibility-plugin-ac"
                  style="max-width: 280px"
                >
                  {{ "HOME.AEFI_REPORTED" | translate }}
                  <span
                    tooltip="Adverse Event Following Immunization"
                    aria-label="Button that displays a tooltip when focused or hovered over"
                    placement="bottom"
                  >
                    <img class="infoicon" src="assets/images/info_icon.svg" />
                  </span>
                </h3>
                <div class="cm-bttn-wrap clearfix accessibility-plugin-ac">
                  <span class="font-weight-bold"
                    >{{ "DASHBOARD.Overall" | translate }} :
                    {{ vaccinatedAefiPer }} %
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="
                      !deviceService.isMobile();
                      else mobileVaccAefiLast7days
                    "
                    id="vaccination-aefi-seven-days"
                    width="600"
                    height="240"
                  ></canvas>
                  <ng-template #mobileVaccAefiLast7days>
                    <canvas
                      id="vaccination-aefi-seven-days"
                      width="600"
                      height="400"
                    ></canvas>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-6 connectedSortable chart-mob-scroll">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title blocktitle accessibility-plugin-ac">
                {{ "DASHBOARD.Rural_Vs_Urban_Trend" | translate }}
              </h3>
            </div>
            <div class="card-body">
              <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                  <canvas
                    *ngIf="!deviceService.isMobile(); else VaccCategoryWise"
                    id="vacc-bycategory"
                    width="600"
                    height="240"
                  ></canvas>
                  <ng-template #VaccCategoryWise>
                    <canvas id="vacc-bycategory" width="600" height="400"
                      >></canvas
                    >
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>

<section class="countertext">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 counter-descp">
        <p>
          <i class="accessibility-plugin-ac"
            >The figure displayed in the dose counter are provisional and are
            subject to reconciliation.</i
          >
        </p>
        <p>
          <i class="accessibility-plugin-ac"
            >The figures for 18 years old (birth year 2004) are included in
            18-44 age group.</i
          >
        </p>
      </div>

      <div class="col-sm-6 lastupdatedtext">
        <p class="accessibility-plugin-ac">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-clock"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
            />
            <path
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"
            />
          </svg>
          Last updated :
          <strong>{{ ReportGenerateTime | date: "yyyy/M/d hh:mm aa" }}</strong>
        </p>
      </div>
    </div>
  </div>
</section>
